export default __webpack_public_path__ + "static/media/heart.c10f8426.gif";